import React from "react";

// Where the store's logo comes from: the owner's own (website editor -> Design); on Ownezzy's demo stores, Ownezzy's
// logo (Super Admin -> Settings, or the one shipped in public/ownezzy); otherwise none, and the type's emoji shows.
// A seller's store never shows Ownezzy's logo.
export function storeLogoUrl(config) {
    if (config.logo) return config.logo;
    if (config.showOwnezzyOffer) return (config.ownezzyBranding && config.ownezzyBranding.logo) || "/ownezzy/logo-192.png";
    return "";
}

// The logo (or emoji) and the store name, for the header, the menu and the footer
export default function StoreBrand({ config, type }) {
    const logo = storeLogoUrl(config);
    return (
        <>
            {logo ? <img className="storeLogo" src={logo} alt="" /> : <span className="storeLogoEmoji" aria-hidden="true">{type.icon}</span>}
            <span>{config.name}</span>
        </>
    );
}
